export default __webpack_public_path__ + "static/media/logo-black.4edc8cb6.png";